export const Authorization = 'Authorization';
export const Token = 'token';
export const UserInfo = 'userInfo';

// sessionStorage key set by an explicit logout and read by the login page's
// auto-SSO redirect. Shared across useLogout and the login page, so it lives
// here — a drift between two hardcoded copies would silently break post-logout
// suppression with no type or lint error.
export const AutoSsoSuppressKey = 'suppressAutoSso';
